export default "__VITE_ASSET__32202274__$_?nuxt_component=async__"